import { UPDATE_LECTURE } from "./types";
import LecturesApi from "../api/LecturesApi";

export const deleteVideo = (courseId, id) => async dispatch => {
  try {
    const lecture = await new LecturesApi().deleteVideo(id, courseId);
    dispatch({
      type: UPDATE_LECTURE,
      payload: { courseId, id, data: lecture.data },
    });
  } catch (error) {
    if (error.response?.status === 403) {
      console.error("No tienes permisos para eliminar el video");
    } else {
      console.error("Error al eliminar el video", error);
    }
    throw error;
  }
};
